import React from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import freedivingTlv from "../static/freediving-tlv.png";
import {Box} from "@mui/system";

const Header = () => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      className="header"
    >
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Box>
                <img alt="freediving-tlv" style={{ width: 200 }} src={freedivingTlv} />
            </Box>
            <Box sx={{padding: "15px"}}>
                <Typography fontWeight={500} textAlign={"center"} variant="h4">
                    {t("header")}
                </Typography>
            </Box>
        </Box>

    </Grid>
  );
};

export default Header;
